<script setup lang="ts">
import { ref } from 'vue'

// state
const inputRef = ref<HTMLInputElement | null>(null)

// model
const model = defineModel<string | number | null>()

// methods
function focus(): void {
  inputRef.value?.focus({ preventScroll: true })
}

async function select(): Promise<void> {
  inputRef.value?.select()
}

// expose
defineExpose({ focus })
</script>

<template>
  <input
    ref="inputRef"
    v-model="model"
    class="text-gray border-darksilver h-full w-10 rounded-sm border border-solid px-1 py-2.5 text-center text-xs font-bold outline-hidden"
    min="0"
    type="number"
    @focus="select()"
  />
</template>

<style scoped>
/* TODO: make it as Tailwind directive or plugin */
/* TODO: refactor other number inputs inside `Application` using this technique */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
